import { Component, OnInit, OnDestroy, OnChanges, SimpleChanges, DoCheck, AfterViewInit, AfterContentInit, AfterViewChecked, AfterContentChecked } from '@angular/core';
import { CurrentPageWatcherService } from '../CurrentPageWatcher';
import { MessageModel } from '../../../model/models';
import { Subscription } from 'rxjs';
import * as $ from 'jquery';

@Component({
  selector: 'app-user-messages',
  templateUrl: './user-messages.component.html',
  styleUrls: ['./user-messages.component.css']
})
export class UserMessagesComponent implements OnInit, OnDestroy {

  userMessagesSubscription : Subscription;

  errorMessages: Array<MessageModel> = [];
  warningMessages: Array<MessageModel> = [];
  infoMessages: Array<MessageModel> = [];
  successMessages: Array<MessageModel> = [];


  constructor(private currentPageWatcher : CurrentPageWatcherService) { 
    $("html, body").animate({ scrollTop: 0 }, "slow");
    this.userMessagesSubscription = this.currentPageWatcher.getUserMessages().subscribe(
      (userMsgs :Array<MessageModel>) => 
      {
        console.log("--------- ",userMsgs);
        this.errorMessages = [];
        this.infoMessages = [];
        this.warningMessages = [];
        this.currentPageWatcher.displayUserMessage = false;
        if (userMsgs != null && userMsgs != undefined) {
          userMsgs.forEach(msg => {
            if (msg.Alert == 0)
              this.infoMessages.push(msg);
            if (msg.Alert == 1)
              this.warningMessages.push(msg);
            if (msg.Alert == 2)
              this.successMessages.push(msg);
            if (msg.Alert == 3)
              this.errorMessages.push(msg);
          })

        }
        else{
          this.errorMessages = [];
          this.infoMessages = [];
          this.warningMessages = [];
          this.successMessages = [];

        }
      }
      );
  }

  ngOnInit() {
    
  }
  ngOnDestroy(): void {
    this.userMessagesSubscription.unsubscribe();
  }

  deleteInfoMessages(){
    this.infoMessages = [];
  }

  deleteWarningMessages(){
    this.warningMessages = [];
  }
  deleteErrorMessages(){
    this.errorMessages = [];
  }
  deleteSuccessMessages(){
    this.successMessages = [];
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/utils/user-messages/user-messages.component.ts